import { useQuery, } from 'react-query';
import { useAutoEnrollmentService } from './use-auto-enrollment-service';
import React from 'react';
import { useFilters } from './use-filters';
import { get } from 'lodash';
import { createContextForController } from 'react-controller-context';
import useCache from '../../../hooks/use-cache';

const emptyObject = {};
const emptyArray = [];

const useController = () => {
    const autoEnrollmentService = useAutoEnrollmentService();
    const { startDate, endDate } = useFilters();

    const key = ['auto-enrollment', 'candidates', `${startDate} ${endDate}`];

    const query = useQuery(
        key,
        () => autoEnrollmentService.getCandidates({ startDate, endDate })
    );
    const { clearCache } = useCache({ key });
    const { isLoading } = query;

    const candidates = React.useMemo(() => query.data || emptyObject, [query.data]);

    const courses = React.useMemo(() => get(query.data, 'courses', emptyArray), [candidates]);

    return {
        isLoading,
        candidates,
        courses,
        clearCache
    };
};

const candidatesCacheContext = createContextForController(useController);
export const useCandidatesCache = candidatesCacheContext.useController;
export const CandidatesCacheProvider = candidatesCacheContext.Provider;
